// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Pin from '../../../../assets/images/Pin.svg'
import { useAppDispatch } from '../../../../hooks/reduxHooks'
import { displayMessage } from '../../../../services/redux/snackbar/snackbar-actions'
import { convertToSearchString } from '../../../../utils/global-utils'

interface MapProps {
    events: EventInPlanningDto[]
    isMapFocused: boolean
}

const Map: React.FC<MapProps> = ({ events, isMapFocused }: MapProps) => {
    const dispatch = useAppDispatch()
    const [validAddressCount, setValidAddressCount] = useState(0);

    useEffect(() => {
        setValidAddressCount(0);
        try {
            const script = document.createElement('script');

            script.src = 'https://api.mapy.cz/loader.js';
            script.id = 'map-loader-script';

            script.onload = async () => {
                window.Loader.async = true;
                window.Loader.load(null, null, async () => {
                    const uniqueAddresses = new Set<string>();

                    const eventCoordsPromises = events.map((event) => {
                        const addressString = `${event.address?.street ? event.address?.street.trim() : ''} ${event.address?.zip ? event.address?.zip.trim() : ''} ${event.address?.city ? event.address?.city.trim() : ''}`;

                        return new Promise((resolve, reject) => {
                            if (uniqueAddresses.has(convertToSearchString(addressString))) {
                                reject('Duplicate address');
                                return;
                            }

                            uniqueAddresses.add(convertToSearchString(addressString));

                            new window.SMap.Geocoder(addressString, (geocoder) => {
                                if (geocoder.getResults()[0].results.length <= 0) {
                                    reject('No coordinates found for event');
                                    return;
                                }
                                const coordsGeo = geocoder.getResults()[0].results[0].coords;
                                const coords = window.SMap.Coords.fromWGS84(coordsGeo.x, coordsGeo.y);
                                resolve(coords);
                            });
                        });
                    });

                    const eventCoordsResults = await Promise.allSettled(eventCoordsPromises);
                    const eventCoords = eventCoordsResults
                        .filter((result) => result.status === 'fulfilled')
                        .map((result) => result.value);

                    // Update the validAddressCount state
                    setValidAddressCount(eventCoords.length);

                    // Map
                    const m = new window.SMap(window.JAK.gel('map'));
                    m.addDefaultLayer(window.SMap.DEF_BASE).enable();
                    m.addDefaultControls();

                    // Set the center and zoom level
                    if (eventCoords.length > 0) {
                        const cz = m.computeCenterZoom(eventCoords);
                        m.setCenterZoom(cz[0], cz[1]);
                    } else {
                        const center = window.SMap.Coords.fromWGS84(14.4179, 50.12655);
                        m.setCenterZoom(center, 7);
                    }

                    // Marker Layer
                    const layer = new window.SMap.Layer.Marker();
                    m.addLayer(layer);
                    layer.enable();

                    // Add markers
                    for (const coords of eventCoords) {
                        const pinWrapper = window.JAK.mel(
                            'div',
                            {},
                            { cursor: 'pointer' }
                        );
                        const image = window.JAK.mel('img', { src: Pin });
                        pinWrapper.appendChild(image);
                        const marker = new window.SMap.Marker(coords, 'myMarker', { url: pinWrapper });
                        layer.addMarker(marker);
                    }
                });
            };

            document.head.append(script);
        } catch (error) {
            dispatch(displayMessage('Nepodařilo se načíst mapu', 'error'))
        }
    }, [isMapFocused]);

    const openUrlWithPlanning = async () => {
        const uniqueAddresses = new Set<string>();

        const eventCoordsPromises = events.map((event) => {
            const addressString = `${event.address?.street ? event.address?.street.trim() : ''} ${event.address?.zip ? event.address?.zip.trim() : ''} ${event.address?.city ? event.address?.city.trim() : ''}`;

            return new Promise((resolve, reject) => {
                if (uniqueAddresses.has(convertToSearchString(addressString))) {
                    reject('Duplicate address');
                    return;
                }

                uniqueAddresses.add(convertToSearchString(addressString));

                new window.SMap.Geocoder(addressString, (geocoder) => {
                    if (geocoder.getResults()[0].results.length <= 0) {
                        reject('No coordinates found for event');
                        return;
                    }
                    const coordsGeo = geocoder.getResults()[0].results[0].coords;
                    const coords = window.SMap.Coords.fromWGS84(coordsGeo.x, coordsGeo.y);
                    resolve(coords);
                });
            });
        });

        const eventCoordsResults = await Promise.allSettled(eventCoordsPromises);
        const eventCoords = eventCoordsResults
            .filter((result) => result.status === 'fulfilled')
            .map((result) => result.value);

        if (eventCoords.length < 2) {
            dispatch(displayMessage('Musejí být alespoň 2 akce s platnou adresou pro otevření plánování trasy.', 'info'))
            return;
        }

        const smapUrl = new window.SMap.URL.Route();

        for (const [index, coords] of eventCoords.entries()) {
            if (index === 0) {
                smapUrl.addStart(coords);
            } else if (index === eventCoords.length - 1) {
                smapUrl.addDestination(coords);
            } else {
                smapUrl.addWaypoint(coords);
            }
        }

        window.open(smapUrl.toString());
    };

    return (<>
        {validAddressCount >= 2 && (
            <Button variant='contained' onClick={openUrlWithPlanning} style={{ marginBottom: '1rem' }}>
                Zobrazit trasu
            </Button>
        )}
        <div id='map' style={{ width: '100%', height: '90vh' }} />
    </>)
}

export default Map